














































































import Vue from 'vue';
import {
  HubButton,
  HubCard,
  HubColorPicker,
  HubFileInput,
  HubIcon,
} from '@/components/HubComponents';
import { image as ApiImage } from '../../services/apiImage/index';
import CustomError from '../../config/CustomError';

interface BackgroundProps {
  option: string;
  color: string;
  imageSource: string | null;
  uploadingImageLoader: boolean;
}

export default Vue.extend({
  name: 'BackgroundContainer',

  components: {
    HubButton,
    HubCard,
    HubColorPicker,
    HubFileInput,
    HubIcon,
  },

  props: {
    value: {
      type: Object as () => BackgroundProps,
      default: {
        option: 'color',
        color: '#ff0000',
        imageSource: null,
        uploadingImageLoader: false,
      },
      required: true,
    },
  },

  data() {
    return {
      uploadEl: null as HTMLElement | null,
      uploadFail: false,
      displayImage: false,
      backgroundFile: undefined,
    };
  },

  computed: {
    backgroundOptions() {
      return [{
        text: this.$t('background_color'),
        option: 'color',
        color: this.value.color,
      },
      {
        text: this.$t('background_image'),
        option: 'image',
        imageSource: this.value.imageSource,
      }];
    },
  },

  watch: {
    value: {
      handler(newValue) { return this.$emit('input', newValue); },
      deep: true,
    },
    async backgroundFile(): Promise<void> {
      this.uploadFail = false;
      this.value.uploadingImageLoader = true;
      const file = this.backgroundFile;

      try {
        if (!file) throw new CustomError('No file selected!');

        const size = (file as File).size / 1024 / 1024;

        if (size > 1) {
          this.$store.dispatch('notification/create', {
            text: this.$t('File size exceeds the limit of 1MB. Please upload a smaller image.'),
            type: 'error',
          }, { root: true });
          throw new CustomError(
            'File is too big. File needs to be less than 1 MB',
          );
        }

        const userInfo = localStorage.getItem('user');
        let odPlanId = '';
        if (userInfo) {
          const customerObjectId = JSON.parse(userInfo);
          odPlanId = customerObjectId.user.od_plan_id;
        }
        const body = new FormData();
        body.set('file', file);
        body.set('noflow', '1');
        body.set('APP', `OD-${odPlanId}`);
        body.set('type', 'BACKGROUND');

        await ApiImage(body)
          .then((res) => {
            const { source } = res.data;
            this.value.imageSource = source;
          })
          .finally(() => {
            this.value.uploadingImageLoader = false;
            // TESTE LOCAL
            // setTimeout(() => { this.value.uploadingImageLoader = false; }, 5000);
          });
      } catch (error) {
        this.uploadFail = true;
        this.value.uploadingImageLoader = false;

        this.$store.dispatch('notification/create', {
          text: 'Erro no upload da imagem de fundo. Tente novamente.',
          type: 'error',
        }, { root: true });

        if (error instanceof CustomError) {
          console.error('[CustomError] => ', error.getMessage());
          return;
        }

        console.error('[Error] => ', error);
      }
    },
  },

  mounted() {
    this.uploadEl = this.$el.querySelector('#uploadEl');
  },

  methods: {
    transferClickToUpload(): void {
      return this.uploadEl?.click();
    },
    log(value: string): void {
      console.log(value);
    },
  },
});
